/**
 * 全屏API
 * @param {HTMLVideoElement} ele 需要全屏的DOM
 */
const launchFullscreen = (ele, callback) => {
    if (ele.requestFullscreen) {
        ele.requestFullscreen();
    } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
    } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
    } else if (ele.oRequestFullscreen) {
        ele.oRequestFullscreen();
    } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullScreen();
    } else if (window.ActiveXObject) {
        const WsShell = new window.ActiveXObject('WScript.Shell');

        WsShell.SendKeys('{F11}');
    } else if (ele.webkitEnterFullscreen) {
        ele.webkitEnterFullscreen();
    } else if (ele.enterFullScreen) {
        ele.enterFullScreen();
    }
    if (callback) {
        callback();
    }
};

export { launchFullscreen };
